export const mairAggregatesDummyData = {
  aiAnsweredCalls: 0,
  aiEngagedCalls: 0,
  appointmentsScheduled: 47,
  appointmentsSchedulingAction: 47,
  appointmentsReschedulingAction: 0,
  unscheduledSchedulingOpportunities: 0,
  recoveredSchedulingOpportunities: 0,
  aiThreads: 1134,
  aiInteractedThreads: 263,
  pendingThreads: 233,
  totalAiConversations: 1134,
  userRespondedConversations: 463,
  appointmentScheduled: 37,
  appointmentRescheduled: 0,
  schedulingLeads: 233,
  scheduledByOthers: 0,
  afterHoursAiConversations: 150,
  afterHoursAppointmentsScheduled: 0,
  totalTasks: 477,
  schedulingTasks: 206,
  nonSchedulingTasks: 271,
  lastPeriod: {
    afterHoursAiConversations: 64,
    afterHoursAppointmentsScheduled: 0,
  },
  pendingTasksCount: 387,
  unscheduledOpportunities: 186,
};
